import { useIsFeatureEnabled } from '../../api/features/features';
import { useDeleteRecentSearches, useGetMruSearches, usePutNavigationSearch } from '../../api/navigation/navigation';
import { SearchableNavEnabled } from '../../utils/FeatureFlags.constants';

export const useMruData = () => {
    const { data: isSearchableNavEnabled, isLoading: isSearchableNavEnabledLoading } = useIsFeatureEnabled({
        featureFlagName: SearchableNavEnabled,
    });

    // if feature flags are loading, isSearchableNavEnabled is undefined. if it's undefined, enabled defaults to true. so we explicitly default to false when undefined
    const {
        data: mruItems,
        isLoading: isMruSearchLoading,
        refetch: refetchMruSearches,
    } = useGetMruSearches({ query: { enabled: isSearchableNavEnabled ?? false } });

    const mruItemsIds: Array<string> =
        mruItems?.navigationRecentSearches?.map((item) => {
            return item.navigationViewId && item.navigationViewId ? item.navigationViewId : '';
        }) || [];

    const { mutateAsync: putNavigationSearch } = usePutNavigationSearch();
    const { mutateAsync: deleteRecentSearches } = useDeleteRecentSearches();

    return {
        isSearchableNavEnabled: isSearchableNavEnabled,
        isMruSearchLoading: isMruSearchLoading || isSearchableNavEnabledLoading,
        refetchMruSearches: refetchMruSearches,
        mruItemsIds: mruItemsIds,
        putNavigationSearch: putNavigationSearch,
        deleteRecentSearches: deleteRecentSearches,
    };
};
